<template>
  <div class="min-h-screen bg-cream-50 text-neutral-900 dark:bg-neutral-950 dark:text-neutral-100">
    <slot />
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'KioskLayout' })
</script>
